import React from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";

import { makeStyles } from "@material-ui/core/styles";

import Input from "@material-ui/core/Input";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { MenuItem } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  select: {
    fontSize: "0.75rem"
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: "0px",
    marginTop: "16px",
    marginRight: "16px"
  },
  typography: {
    color: "rgba(0, 0, 0, 0.54)",
    padding: 0,
    fontSize: "1rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: "translate(0, 1.5px) scale(0.75)",
    transformOrigin: "top left",
    letterSpacing: "0.00938em",
    transition:
      "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
  }
}));

const Campaign = ({
  type,
  onChange,
  disabled,
  value,
  error,
  children,
  title,
  campaign_data,
  subcontact_types,
  ...props
}) => {
  const handleChange = event => {
    onChange(event, "campaign_data");
  };

  const classes = useStyles();
  const send_campaigns = [
    { id: 0, name: "No" },
    { id: 1, name: "Si" }
  ];
  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>
      <FormControl
        required
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>
          Enviar estados vehículos?
        </Typography>
        <Select
          native
          name="send_campaign"
          inputProps={{
            name: "send_campaign",
            className: "send_campaign"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          value={campaign_data.send_campaign}
          input={<Input id="grouped-native-select" name="send_campaign" />}
        >
          <option value="" label="Seleccione" />
          {send_campaigns.map(send_campaign => (
            <option id={send_campaign.id} value={send_campaign.id}>
              {send_campaign.name}
            </option>
          ))}
        </Select>
      </FormControl>
      {parseInt(campaign_data.send_campaign) === 1 && (
        <FormControl
          required
          className={classes.formControl}
          inputProps={{ shrink: true }}
        >
          <Typography className={classes.typography}>
            Tipo de subcontacto
          </Typography>
          <Select
            native
            name="campaign_subcontact_type_id"
            inputProps={{
              name: "campaign_subcontact_type_id",
              className: "campaign_subcontact_type_id"
            }}
            style={{ minWidth: 150, fontSize: "0.75rem" }}
            disabled={disabled}
            onChange={handleChange}
            value={campaign_data.campaign_subcontact_type_id}
            input={
              <Input
                id="grouped-native-select"
                name="campaign_subcontact_type_id"
              />
            }
          >
            <option value="" label="Seleccione" />
            {subcontact_types.map(subcontact_type => (
              <option id={subcontact_type.id} value={subcontact_type.id}>
                {subcontact_type.name}
              </option>
            ))}
          </Select>
        </FormControl>
      )}
      <FormControl
        required
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>Enviar encuesta?</Typography>
        <Select
          native
          name="send_survey"
          inputProps={{
            name: "send_survey",
            className: "send_survey"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          value={campaign_data.send_survey}
          input={<Input id="grouped-native-select" name="send_survey" />}
        >
          <option value="" label="Seleccione" />
          {send_campaigns.map(send_campaign => (
            <option id={send_campaign.id} value={send_campaign.id}>
              {send_campaign.name}
            </option>
          ))}
        </Select>
      </FormControl>
    </React.Fragment>
  );
};

export default Campaign;
